import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/wage-actions';
import { WageActions } from '../constants';
import { IWage } from 'src/types/wage';

export interface WageState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IWage>;
    current: IWage | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function wages(state: WageState = initialState, action: Actions | any): WageState {
    switch (action.type) {
        case requestType(WageActions.PERSIST_WAGE):
            return { ...state, error: '', inProgress: true };
        case successType(WageActions.PERSIST_WAGE):
            return { ...state, inProgress: false };
        case failureType(WageActions.PERSIST_WAGE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(WageActions.FETCH_WAGES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };

        case successType(WageActions.FETCH_WAGES):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(WageActions.FETCH_WAGES):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(WageActions.FETCH_WAGE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(WageActions.FETCH_WAGE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(WageActions.FETCH_WAGE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(WageActions.DELETE_WAGE):
            return { ...state, error: '', inProgress: true };
        case successType(WageActions.DELETE_WAGE):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IWage) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(WageActions.DELETE_WAGE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
